export const WAIT_FOR_MESSAGE_TIMEOUT = 30000;
